<template>
  <div id="qualifications">
    <v-app>
      <QualificationsDisplay v-if='loaded'/>
    </v-app>
  </div>
</template>

<script>
import QualificationsDisplay from './views/QualificationsDisplay.vue'

export default {
  name: 'qualifications',
  components: {
    QualificationsDisplay,
  },
  data() {
    return {
      loaded: false
    }
  },
  async beforeCreate() {
    try {
      // load feature flags
      await this.$features.$waitForLoad()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Encountered an error loading feature flags. The application will proceed with all optional features disabled')
      // eslint-disable-next-line no-console
      console.error('Feature loading error:', e)
    }
    this.loaded = true
  }
}

// This causes jest to ignore this file for coverage as it's not pertinent
/* istanbul ignore file */
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: transparent;
}
</style>
